var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "People/user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.83333 6.66667C6.83333 4.91776 8.2511 3.5 10 3.5C11.7489 3.5 13.1667 4.91776 13.1667 6.66667C13.1667 8.41557 11.7489 9.83333 10 9.83333C8.2511 9.83333 6.83333 8.41557 6.83333 6.66667ZM13.4125 10.5461C14.488 9.59926 15.1667 8.21221 15.1667 6.66667C15.1667 3.8132 12.8535 1.5 10 1.5C7.14653 1.5 4.83333 3.8132 4.83333 6.66667C4.83333 8.21221 5.51196 9.59926 6.58749 10.5461C3.59213 11.8606 1.5 14.8526 1.5 18.3333H3.5C3.5 14.7435 6.41015 11.8333 10 11.8333C13.5899 11.8333 16.5 14.7435 16.5 18.3333H18.5C18.5 14.8526 16.4079 11.8606 13.4125 10.5461Z",
    fill: "#717171"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.c477d77702ea7ee3ac517352e9f5a983.svg";
export { ForwardRef as ReactComponent };